import { FC } from 'react';

import { Spin } from 'antd';

type Props = React.ComponentProps<typeof Spin>;

export const CenteredSpin: FC<Props> = (props) => {
	return (
		<Spin
			size="large"
			style={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				zIndex: 2000,
				transform: 'translate(-50%, -50%)',
			}}
			{...props}
		/>
	);
};
